<template>
  <v-main>
    <PopupAlert v-model="showRedeemed" type="redeemed" @click:keep="handlekeep" />
    <v-container v-if="!$store.state.isLoading">
      <div class="article">
        <BackOnTop title="詳細內容" :url="url" />
        <div class="title_area">
          <div class="ticket_container">
            <div class="dot_container" :style="{top: `${svgHeight}px`}">
              <div class="dot" v-for="i in 10" :key="i"></div>
            </div>
            <div id="d_ticket" class="d_ticket" :style="{ clipPath: `path('${pathT}')` }">
              <div class="title2-semibold" style="margin-bottom: 9px;">{{ newsData.title }}</div>
              <div class="" style="display: flex;gap:8px;align-items:center;justify-content: center;">
                <div class="body-medium" style="color: #FF9F4B">{{ newsData.sub }}</div>
                <div class="caption-regular" style="color: #909090">{{ newsData.sub2 }}</div>
              </div>
            </div>
            <div id="d_ticket2" class="d_ticket2" :style="{ clipPath: `path('${pathB}')` }">
              <!-- 優惠已使用 -->
              <img
                src="@/assets/images/ic_ticket_expired.svg"
                v-if="status === 'counting' || (isused && finished === 'counting')"
                class="done_img"
                alt=""
              />
              <img
                src="@/assets/images/ic_ticket.svg"
                v-if="status === 'redeemed' || (isused && finished === 'redeemed')"
                class="done_img"
                alt=""
              />
              <div v-if="(finished !== 'redeemed' || !isused) && status !== 'redeemed' && status !== 'counting'" class="warn_word">
                尚未產生QR Code
              </div>
              <qrcode-vue :value="qrcode" :size="qrwidth" :class="{'non_see': !enableqrcode && finished !== 'redeemed' ,'is_get': finished !== 'redeemed' || !isused, 'is_init': status === 'redeemed' }"></qrcode-vue>
            </div>
          </div>
          <div class="detail_area">
            <div class="detail">
              <font class="title2-medium-custom" style="color: #0D0C0C">{{ newsData.type }}</font>
              <div class="" style="display: flex; gap: 6px; flex-direction: column;">
                <div class="body-regular-custom" v-html="newsData.content"></div>
                <!-- <div class="body-regular">領取期限 : <span style="color: #FF9F4B">{{ newsData.getTime.replace(/-/g, '/') }}</span></div> -->
                <div class="body-regular-custom">兌換期限 : <span style="color: #FF9F4B">{{ newsData.setTime.replace(/-/g, '/') }}</span></div>
              </div>
            </div>
            <div v-if="$route.query.type == '最新消息'" class="arrow_area d_flex">
              <div v-if="prev" @click="redirect(prev)" class="prev">
                <img src="~@/assets/images/prevPage.svg" alt="" /><font>上一篇</font>
              </div>
              <div v-if="next" @click="redirect(next)" class="next">
                <font>下一篇</font><img src="~@/assets/images/prevPage.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
        <!-- <img
          v-if="
            $route.query.type != '最新消息' &&
            $route.query.type != '獸醫聊天室' &&
            $route.query.type != '寵物生鮮食' &&
            $route.query.type != '寵知識'
          "
          :src="newsData.imgSrc"
          alt=""
        /> -->
        <div class="content">
          <h5
            v-if="
              $route.query.type != '獸醫聊天室' &&
              $route.query.type != '寵物生鮮食' &&
              $route.query.type != '寵知識'
            "
            class="title2-medium-custom"
            style="color: #0D0C0C;font-size: 16px;"
          >
            注意事項
          </h5>
          <p v-html="newsData.note" class="editer" />
        </div>
        <!-- 判斷按鈕狀態 -->
        <!-- 領取優惠 -->
        <!-- <v-btn
          style="margin-bottom: 24px;"
          rounded
          :color="countDown === 0 ? 'primary' : 'grey'"
          @click="couponHandler"
          v-if="status === 'counting'"
        >
          領取優惠券 <font v-if="!!countDown">{{ countDown }}s</font>
        </v-btn> -->

        <!-- 兌換優惠 -->
        <div v-if="status === 'getCoupon' || status === 'redeemed' || status === 'counting'" class="btn-container btn" :style="{color: !enableqrcode || status === 'redeemed' || isused ?'#6f6f6f':'white'}" :class="{'non_click': !enableqrcode || status === 'redeemed' || isused}" @click="showRedeemed = true">
          <p class="body-semibold">確認兌換(店員專用)</p>
          <v-btn class="" style="width: 24px; height: 24px; margin: 0;" icon>
            <img alt="logo" :src="!enableqrcode || status === 'redeemed' || isused ? require('@/assets/images/btn_keepGray.svg'):require('@/assets/images/btn_keep.svg')" />
          </v-btn>
        </div>
        <!-- <FancyInputNoBorder
          v-if="status === 'getCoupon' && redeemCouponDisabled"
          v-model="redeemCouponCode"
          placeholder="優惠券兌換請洽門市人員"
          type="text"
          persistent-hint
          class="no_border"
          filled
        /> -->
      </div>
    </v-container>

    <!-- 燈箱區 -->
    <!-- 看完廣告領優惠券 -->
    <FancyDialog v-model="lbCouponOpen">
      <v-container fluid class="dialog_container">
        <img width="90" height="90" class="mb-5" src="@/assets/images/lb_check.svg" alt="" />
        <p class="title mb-8">已領取優惠券</p>
        <FancyButton class="btn" color="primary" label="前往優惠券" to="coupon?type=use" />
      </v-container>
    </FancyDialog>

    <!-- 看完廣告領優惠券 -->
    <FancyDialog v-model="lbErrorOpen">
      <v-container fluid>
        <img width="90" height="90" class="mb-5" src="@/assets/images/imgWarning.svg" alt="" />
        <p class="title mb-3">代碼錯誤</p>
        <font class="f_black mb-8">請洽門市人員</font>
        <FancyButton class="btn" color="primary" label="確定" @click="clearCodeInput" />
      </v-container>
    </FancyDialog>

    <!-- 優惠券的QRcode-->
    <!-- <LB :open="lbQRcodeOpen" @closeLb="closeLb" class="lb">
      <h4><font>兌換優惠券</font></h4>
      <div class="d_flex">
        <img src="@/assets/images/paw.gif" class="paw" alt="" />
        <p class="f_grey">倒數{{ countDown }}秒自動關閉頁面</p>
        <div class="qrcode_wrapper">
          <qrcode-vue :value="qrcode"></qrcode-vue>
        </div>
      </div>
    </LB> -->
  </v-main>
</template>

<script>
import BackOnTop from '@/components/BackOnTop.vue'
import FancyButton from '@/components/FancyButton.vue'
// import BtnSign from '@/components/BtnSign.vue'
import FancyDialog from '@/components/FancyDialog.vue'
import PopupAlert from '@/components/Popup/PopupAlert.vue'
// import FancyInputNoBorder from '@/components/FancyInputNoBorder.vue'
// import LB from '@/components/LB.vue'
import QrcodeVue from 'qrcode.vue'
import {
  getArticlePage,
  getCouponContent,
  getCouponImage,
  useCoupon,
  getCoupon,
  getArticle,
} from '@/apis/api.js'
export default {
  name: 'NewsArticle',
  components: {
    BackOnTop,
    FancyDialog,
    PopupAlert,
    // LB,
    // BtnSign,
    FancyButton,
    // FancyInputNoBorder,
    QrcodeVue,
  },

  data: () => ({
    finished: false,
    showRedeemed: false,
    newsData: {
      type: '',
      setTime: '',
      getTime: '',
      title: '',
      sub: '',
      sub2: '',
      detail: '',
      content: '',
      imgSrc: '',
      article_id: '',
      category_id: '',
      note: ''
    },

    svgHeight: 0,
    pathT: '',
    pathB: '',
    prev: 'xyz1234',
    next: 'opq6789',
    countDown: 60,
    lbCouponOpen: false,
    lbQRcodeOpen: false,
    lbErrorOpen: false,
    redeemCouponDisabled: false,
    redeemCouponCode: '',
    fetchArticle: false,
    containerWidth: 0,
    url: '',
    qrcode: '',
    isused: false,
    getDateStart: [],
    getDateEnd: [],
    enableqrcode: false,
  }),
  computed: {
    status() {
      const {
        query: { status },
      } = this.$route
      return status
    },
    qrwidth() {
      return this.containerWidth / 3
    }
  },
  beforeCreate() {
    this.$store.state.isLoading = true
  },
  created() {
    const {
      query: { type, category_id, page },
    } = this.$route
    if (type) this.newsData.type = type
    if (category_id) this.newsData.category_id = category_id
    if (page) this.newsData.page = page

    if (this.status === 'counting') this.timer()

    if (this.newsData.type == '最新消息') this.url = '/info?type=msg'
    else if (this.$route.query.type == '優惠票卷' && this.$route.query.status == 'getCoupon')
      this.url = '/info/coupon?type=use'
    else if (this.$route.query.type == '優惠票卷' && this.$route.query.status == 'redeemed')
      this.url = '/info/coupon?type=done'
    else if (this.$route.query.type == '優惠票卷' && this.$route.query.status == 'counting')
      this.url = '/info/coupon?type=unget'
    var parent = this
    // if(this.$route.query.type == "寵知識"){
    //     parent.newsData = {
    //         type: '寵知識',
    //         time: '2021/08/10',
    //         title: '乾糧好？還是濕糧好？',
    //         detail: '乾糧好？還是濕糧好？',
    //         content: '<img src="http://cms.greattreepets.com/upload/article/knowledge/yxwdnkYFZZupneZGcL8l1CFGzPv6wPVY1x0jq2xt.png"/>',
    //         // imgSrc: require('../../assets/images/img_03.jpg'),
    //         imgSrc:'',
    //         article_id: '941e6101-7ae7-4df5-9b28-d40eaf2c84bb',
    //         category_id: '寵知識'
    //     }
    // } else if(this.$route.query.type == "獸醫聊天室"){
    //     parent.newsData = {
    //         type: '獸醫聊天室',
    //         time: '2021/08/12',
    //         title: '淺談跳蚤過敏性皮膚炎(Flea Allergy Dermatitis)',
    //         detail: '淺談跳蚤過敏性皮膚炎(Flea Allergy Dermatitis)',
    //         content: '<div data-v-03d6fa94="" class="article-contents"><p>蟲蟲大軍中的跳蚤真的很可怕，除了叮咬主人跟毛小孩造成搔癢外，也會造成毛孩的皮膚病喔，那這皮膚病會傳染人嗎？該怎麼預防跟治療呢？來聽獸醫師聊聊吧。</p><p><strong>一、特性</strong></p><ul><li><p>春夏季常見的皮膚疾病</p></li><li><p>發作快速</p></li><li><p>為搔癢丘疹性皮膚炎</p></li><li><p>主要為動物對跳蚤產生的抗原具有過敏性的反應</p></li><li><p>通常動物本身有異位性皮膚炎</p></li><li><p>2/3以上身上找不到跳蚤，因為這種搔癢感可能在跳蚤最後一次叮咬後，持續2個星期以上</p></li><li><p>身上可能發現黑色的屑屑(像沙子一樣)，那是跳蚤的便便，遇水會溶成紅色</p></li></ul><p><img src="http://cms.greattreepets.com/upload/article/veterinary/Lji9iO5KJvxzsNkfTocsGl328NcAoG6rYRtlIIK1.png" width="1200"></p><p><strong>二、症狀</strong></p><ul style="list-style-type: circle;"><li>狗</li></ul><ul><li style="list-style-type: none;"><ul style="list-style-type: square;"><li><p>好發於臀部、尾根部、和鼠蹊部</p></li><li><p>產生丘疹、結痂、濕疹、膿皮症等</p></li></ul></li></ul><p><img src="http://cms.greattreepets.com/upload/article/veterinary/SvD0bavM62TsJgvHwyDZzaKH0YauvRYuEX3GR1yh.png" width="1200"></p><ul style="list-style-type: circle;"><li>貓</li></ul><ul><li style="list-style-type: none;"><ul style="list-style-type: square;"><li><p>對於跳蚤叮咬過敏更敏感</p></li><li><p>好發於頭部、頸部、腰薦椎、背部</p></li><li><p>產生粟粒狀皮膚炎、對稱性脫毛等</p></li></ul></li></ul><p><img src="http://cms.greattreepets.com/upload/article/veterinary/CR0jOkNs4Uxf5E4dVtfhXpSyWraC5x1Ietj292Vz.png" width="1200"></p><p><strong>三、治療</strong></p><ol><li><p>去除跳蚤是治癒唯一的辦法。</p></li><li><p>皮膚炎的部分還是要帶去看獸醫師治療，因為毛孩就跟小孩一樣不聽人話，很癢就會抓到受傷流血還繼續抓跟咬，該把頭套戴起來就要戴。</p></li><li><p>定期使用外寄生蟲預防藥，不知道該買哪種就問獸醫師，貓咪不可以用含除蟲菊(permethrin)類的藥物會中毒喔！</p></li></ol><p style="text-align: justify;">最後飼主一定有疑問，那到底會不會傳染給人呢？</p><p style="text-align: justify;">皮膚病的部分不會傳染給人類，只是跳蚤也會叮咬人，通常都是好幾個併在一起且小小突起的疹子，而且會很癢！當然有些人也是會對跳蚤叮咬產生過敏，這時就建議找專業的皮膚科醫師來診療。</p><p style="text-align: justify;">如果可以，建議家裡要大消毒，除了成年的跳蚤可以存活在環境好幾個月之外，跳蚤的蛹可以在不利生存的環境下存在很久很久，只為了等到適合的環境出現才甘願破蛹而出，因此跳蚤蛹絕對是一個難纏的敵人！</p><p style="text-align: justify;">另外水煙式殺蟲劑大部分是除蟲菊類的成分，如果家裡有貓咪又真的要使用，就要特別小心，最好是水煙噴過的地方全部都再用清水擦幾次。</p><p style="text-align: right;">作者：馮芷若 獸醫師</p></div>',
    //         // imgSrc: require('../../assets/images/img_03.jpg'),
    //         imgSrc:'',
    //         article_id: '941e6101-7ae7-4df5-9b28-d40eaf2c84bb',
    //         category_id: '獸醫聊天室'
    //     }
    // } else if(this.$route.query.type == "寵物生鮮食"){
    //     parent.newsData = {
    //         type: '寵物生鮮食',
    //         time: '2021/08/16',
    //         title: '如何讓貓狗成功轉食生食',
    //         detail: '如何讓貓狗成功轉食生食',
    //         content: '<div data-v-03d6fa94="" class="side-contents"><div data-v-03d6fa94="" class="article"><div data-v-03d6fa94="" class="writings-title"><!----> <h1 data-v-03d6fa94="">如何讓貓狗成功轉食生食</h1> <time data-v-03d6fa94="">2021/08/10</time></div> <div data-v-03d6fa94="" class="article-contents"><p><img src="http://cms.greattreepets.com/upload/article/knowledge/38cnAo3DpkxDdPIY8ZXEbhFPys988NoM8VfVWsjP.png"></p><p>近年來，有越來越多的飼主想嘗試給自家的毛孩吃生食，有的毛孩完全沒有適應問題，有的卻屢次失敗。有沒有什麼方法可以讓家裡的毛孩轉食成功呢？</p><h3 data-sr-id="6">轉食技巧一：漸進式轉食</h3><p data-sr-id="7">透過漸進式轉食法，讓毛孩不管是腸胃上或是心態上都能漸漸習慣生食，減少轉食過程的不順利。</p><p><img src="http://cms.greattreepets.com/upload/article/knowledge/RLh3OtHDB8L8I25Vm1AOuPaA24YTMmV2T6ZBeTCD.png"></p><p data-sr-id="8">◎如何漸進式轉食呢？</p><ol><li><p>以狗狗來說：全熟食→一餐熟食、一餐生食→全生食<br>通常狗狗的轉食相對來說是比較容易的，通常能直接轉食過去。<br>但有的狗可能有疾病狀況(如：糖尿病)、腸胃較敏弱、一餓就吐胃酸，還是建議使用漸進式轉食法。</p></li><li><p>以貓咪來說：<br>全熟食→定時定量熟食<br>→挑一餐換生食，且前一餐熟食量變少<br>→慢慢增加生食的份量與餐數<br>→全生食<br>每個階段皆持續3-7天，並觀察是否有不適應的問題。<br>另外貓咪比較固執，有的貓就算餓，不吃就是不吃！況且貓咪一但餓超過36小時，就容易增加脂肪肝的風險，嚴重甚至會有黃疸的問題。<br>因此，貓咪在轉食的過程中，建議都是使用漸進式轉食比較恰當！</p></li></ol><h3 data-sr-id="9">轉食技巧二：挑對季節，冬天比夏天更適合</h3><p data-sr-id="9">一般來說夏天天氣熱，毛孩的食慾通常會比較差，這時若幫毛孩轉食，很常會因為不想吃、不喜歡吃、不習慣吃、沒吃過而失敗。<br>反而冬天因為天氣冷，會吃得比較多，因此冬天是最好練習轉食的季節。<br><img src="http://cms.greattreepets.com/upload/article/knowledge/Q4B6wXgbpX6IWvpOKxcayECLbx0SXAVfzaEyHj3o.png"></p><h3 data-sr-id="9">轉食技巧三：決心、耐心、多觀察</h3><p data-sr-id="9">首先，毛爸媽要先瞭解，轉生食並不是每一個毛孩都能很順利，最好要有長期抗戰的準備(尤其是貓咪)！而且轉食很容易因為毛孩不吃而丟棄許多的肉品，這點也是飼主需要注意的，如果食物放了30分鐘還是沒吃完就建議丟棄避免滋生細菌，再讓貓咪繼續吃會生病的喔！<br><br>第二，毛爸媽的想法，如果真的想讓毛孩轉食成功，就必須下定決心，千萬不要用試試看的想法來實行。<br><br>第三，用耐心陪著毛孩轉食。轉食過程中毛孩可能會因為對某些肉品過敏而有腸胃不適或嘔吐的狀況，毛爸媽需要耐心觀察紀錄何種肉品所造成。另外，尤其是貓咪的漸進式轉食，可能每次給的生食都不被接受，就需要不斷地誘食、鼓勵，緩慢的增加生食的份量，如果沒有耐心，在這段過程中很容易就投降放棄了。<br><br><img src="http://cms.greattreepets.com/upload/article/knowledge/rIoHD1bBtgWFRVxCLZvc1yq2IzrsRouQGLIn6dHt.png"></p><h3 data-sr-id="9">轉食技巧四：誘導與鼓勵</h3><p>對於已經習慣吃乾飼料的毛孩，轉食過程中可以在新的食物中加一些他們最喜歡的食物來誘導他們進食，比如像：寵物肉鬆、肉泥、副食罐或是在生肉上澆一點熱水讓肉散發出香味。當他們願意開始嘗試第一口生食、願意把提供的生食吃掉一部分或是全部吃完，可以抱抱、親拍、或給予零食鼓勵稱讚他們。</p><p>畢竟他們可能從來沒吃過生食，根本不曉得這是可以吃的食物，千萬不要勉強他們。我們可以透過誘導和鼓勵，讓他們勇敢嘗試、跨出第一步。</p></div></div></div>',
    //         // imgSrc: require('../../assets/images/img_03.jpg'),
    //         imgSrc:'',
    //         article_id: '941e6101-7ae7-4df5-9b28-d40eaf2c84bb',
    //         category_id: '寵物生鮮食'
    //     }
    // } else
    if (this.$route.query.type == '優惠票卷') {
      getCouponContent(this.$route.query.id).then(function (content) {
        getCouponImage(parent.$route.query.id).then(function (image_url) {
          parent.newsData = {
            type: '優惠票卷',
            setTime:
              [
                parent.$route.query.startDate.slice(0, 4),
                parent.$route.query.startDate.slice(4, 6),
                parent.$route.query.startDate.slice(6, 8),
              ].join('/') +
              ' ~ ' +
              [
                parent.$route.query.endDate.slice(0, 4),
                parent.$route.query.endDate.slice(4, 6),
                parent.$route.query.endDate.slice(6, 8),
              ].join('/'),
            getTime:
              [
                parent.$route.query.s_date_receive.slice(0, 4),
                parent.$route.query.s_date_receive.slice(4, 6),
                parent.$route.query.s_date_receive.slice(6, 8),
              ].join('/') +
              ' ~ ' +
              [
                parent.$route.query.e_date_receive.slice(0, 4),
                parent.$route.query.e_date_receive.slice(4, 6),
                parent.$route.query.e_date_receive.slice(6, 8),
              ].join('/'),
            title: parent.$route.query.title,
            sub: parent.$route.query.sub,
            sub2: parent.$route.query.sub2,
            detail: parent.$route.query.sub,
            content: parent.$route.query.content,
            imgSrc: image_url,
            article_id: parent.$route.query.id,
            category_id: parent.$route.query.type,
            note: content
          }
          if (parent.$route.query.timing == '' || !parent.$route.query.timing) parent.countDown = 60
          else
            parent.countDown =
              parseInt(parent.$route.query.timing) < 0 ? 0 : parseInt(parent.$route.query.timing)
          parent.$store.state.isLoading = false
        })
      })
    } else {
      this.fetchArticle = true
      // this.$store.state.isLoading = false
      // getArticle(this.newsData.category_id,this.newsData.article_id).then(function(rsp){
      //     console.log("getArticle",rsp);
      //     if(rsp) {
      //         var temp_type = "";
      //         if(parent.$route.query.type == "news.lates") temp_type = "活動快訊";
      //         else if(parent.$route.query.type == "news.promotion") temp_type = "優惠訊息";
      //         // else if(parent.$route.query.type == "knowledge") temp_type = "寵知識";
      //         // else if(parent.$route.query.type == "veterinary") temp_type = "獸醫聊天室";
      //         else temp_type = type
      //         parent.newsData = {
      //             type: temp_type,
      //             time: rsp.created_at.split(" ")[0],
      //             title: rsp.title,
      //             detail: rsp.subject,
      //             content: rsp.content,
      //             imgSrc: rsp.pic_url,
      //             article_id: rsp.id,
      //             category_id: parent.$route.query.type
      //         }
      //     }
      // })
    }
  },
  mounted() {
    this.getWidth()
    window.addEventListener('resize', this.getWidth)
    window.addEventListener('resize', this.svgResize)
    window.addEventListener('resize', this.svgResize2)
    this.$nextTick(() => {
      this.calDateTime()
      setTimeout(() => {
        this.svgResize()
        this.svgResize2()
      }, 100);
    })
  },
  methods: {
    calDateTime() {
      let parent = this
      const now = new Date();
      const dateMonth = now.getMonth() + 1 >= 10 ? now.getMonth() + 1 : `0${now.getMonth() + 1}`
      const dateNow = parseInt(`${now.getFullYear()}${dateMonth}${now.getDate()<10?`0${now.getDate()}`:`${now.getDate()}`}`)
      const dateStart = parseInt(parent.$route.query.startDate)
      const dateEnd = parseInt(parent.$route.query.endDate)
      
      parent.enableqrcode = dateStart <= dateNow && dateEnd >= dateNow
    },
    getWidth() {
      this.containerWidth = Math.min(700, window.innerWidth)
    },
    svgResize() {
      let parent = this
      const d_ticket = document.getElementById('d_ticket')
      const rect = d_ticket.getBoundingClientRect()
      const width = rect.width
      const height = rect.height
      parent.svgHeight = height
      const radius = 7
      const border = 18
      parent.pathT = `M${border} 0 L${width - border} 0 A${border} ${border} 0 0 1 ${width} ${border} L${width} ${height - 7} A${radius} ${radius} 0 0 0 ${width - 7} ${height} L${radius} ${height} A${radius} ${radius} 0 0 0 0 ${height - 7} L0 ${border} A${border} ${border} 0 0 1 ${border} 0 Z`
    },
    svgResize2() {
      let parent = this
      const d_ticket2 = document.getElementById('d_ticket2')
      const rect = d_ticket2.getBoundingClientRect()
      const width = rect.width
      const height = rect.height
      const radius = 7
      const border = 18
      parent.pathB = `M${radius} 0 L${width - radius} 0 A${radius} ${radius} 0 0 0 ${width} ${radius} L${width} ${height - border} A${radius} ${radius} 0 0 0 ${width} 7 L${width} ${height - border} A${border} ${border} 0 0 1 ${width - border} ${height} L${border} ${height} A${border} ${border} 0 0 1 0 ${height - border} L0 ${radius} A${radius} ${radius} 0 0 0 ${radius} 0 Z`
    },
    timer() {
      this.time = setInterval(() => {
        if (this.countDown <= 0) {
          this.stopTime()
        } else {
          this.countDown = this.countDown - 1
        }
      }, 1000)
    },
    stopTime() {
      if (this.time) {
        clearInterval(this.time)
        if (this.status === 'getCoupon') {
          this.lbQRcodeOpen = false
          this.redeemCouponCode = ''
          // var temp_query = this.$route.query;
          // this.lbCouponOpen = true;
          console.log('///')
          this.$router.push('/info/coupon?type=use')
        }
      }
    },
    couponHandler() {
      var parent = this
      if (this.countDown === 0) {
        getCoupon(
          localStorage.getItem('phone'),
          localStorage.getItem('password'),
          this.$route.query.id
        ).then(function (rsp) {
          if (rsp) parent.lbCouponOpen = true
        })
      }
    },
    handlekeep() {
      this.redeemCoupon()
    },
    redeemCoupon() {
      var parent = this
      useCoupon(
        localStorage.getItem('phone'),
        localStorage.getItem('password'),
        this.redeemCouponCode,
        this.$route.query.id,
        this.$route.query.pcid
      ).then(function (rsp) {
        if (rsp != '-1') {
          if (rsp) parent.qrcode = rsp
          else parent.qrcode = parent.redeemCouponCode
          
          parent.lbQRcodeOpen = true
          parent.isused = true
          parent.finished = 'redeemed'
          parent.redeemCouponDisabled = false
          // timer改為60
          parent.countDown = 60
          parent.timer()
          // setTimeout(() => {
          //   parent.$router.go(-1)
          // }, 1000);
        } else {
          parent.lbErrorOpen = true
        }
      })
      // if (this.redeemCouponDisabled) {
      //   //已經打開的狀態，送出驗證碼
      //   useCoupon(
      //     localStorage.getItem('phone'),
      //     localStorage.getItem('password'),
      //     this.redeemCouponCode,
      //     this.$route.query.id,
      //     this.$route.query.pcid
      //   ).then(function (rsp) {
      //     if (rsp != '-1') {
      //       if (rsp) parent.qrcode = rsp
      //       else parent.qrcode = parent.redeemCouponCode

      //       parent.lbQRcodeOpen = true
      //       parent.isused = true
      //       parent.redeemCouponDisabled = false
      //       // timer改為60
      //       parent.countDown = 60
      //       parent.timer()
      //     } else {
      //       parent.lbErrorOpen = true
      //     }
      //   })
      // } else {
      //   this.redeemCouponDisabled = true
      // }
    },
    closeLb() {
      this.lbQRcodeOpen = false
      this.$router.push({
        path: 'news',
        query: {
          article_id: this.newsData.article_id,
          status: 'redeemed',
        },
      })
    },
    clearCodeInput() {
      this.lbErrorOpen = false
      this.redeemCouponCode = ''
    },
    redirect(obj) {
      this.newsData.category_id = obj.category_id
      this.newsData.page = obj.page
      this.fetchArticle = true
    },
  },
  watch: {
    fetchArticle() {
      var parent = this
      this.$store.state.isLoading = true
      if (this.fetchArticle) {
        this.fetchArticle = false
        console.log('this.newsData.page', this.newsData.page)
        if (this.newsData.page) {
          getArticlePage(this.newsData.category_id, this.newsData.page).then(function (rsp) {
            console.log(getArticlePage, rsp)
            if (rsp) {
              var temp_type = ''
              if (parent.$route.query.type == 'news.lates') temp_type = '活動快訊'
              else if (parent.$route.query.type == 'news.promotion') temp_type = '優惠訊息'
              else temp_type = parent.newsData.type
              parent.newsData = {
                type: temp_type,
                time: rsp.data[0].created_at.split(' ')[0],
                title: rsp.data[0].title,
                detail: rsp.data[0].subject,
                content: rsp.data[0].content.replaceAll('http://', 'https://'),
                imgSrc: rsp.data[0].pic_url.replaceAll(
                  'http://cms.greattreepets.com',
                  'https://cms.greattreepets.com'
                ),
                article_id: rsp.data[0].id,
                category_id: parent.$route.query.type,
              }
              if (rsp.links.prev) {
                var prev_category_id = rsp.links.prev.split('pet/articles/pages/')[1].split('?')[0]
                var prev_page = rsp.links.prev.split('pet/articles/pages/')[1].split('?page=')[1]
                parent.prev = {
                  category_id: prev_category_id,
                  page: prev_page,
                  type: parent.$route.query.type,
                }
              } else {
                parent.prev = null
              }
              if (rsp.links.next) {
                var next_category_id = rsp.links.next.split('pet/articles/pages/')[1].split('?')[0]
                var next_page = rsp.links.next.split('pet/articles/pages/')[1].split('?page=')[1]
                parent.next = {
                  category_id: next_category_id,
                  page: next_page,
                  type: parent.$route.query.type,
                }
              } else {
                parent.next = null
              }
              setTimeout(function () {
                parent.$store.state.isLoading = false
              }, 1000)
            }
          })
        } else {
          getArticle(this.newsData.category_id, this.$route.query.article_id).then(function (rsp) {
            console.log('getArticle', rsp)
            if (rsp) {
              var temp_type = ''
              if (parent.$route.query.type == 'news.lates') temp_type = '活動快訊'
              else if (parent.$route.query.type == 'news.promotion') temp_type = '優惠訊息'
              else temp_type = parent.newsData.type

              parent.newsData = {
                type: temp_type,
                time: rsp.created_at.split(' ')[0],
                title: rsp.title,
                detail: rsp.subject,
                content: rsp.content.replaceAll('http://', 'https://'),
                imgSrc: rsp.pic_url.replaceAll('http://', 'https://'),
                article_id: rsp.id,
                category_id: parent.$route.query.type,
              }

              parent.prev = null
              parent.next = null
              setTimeout(function () {
                parent.$store.state.isLoading = false
              }, 1000)
            }
          })
        }
      }
    },
    '$store.state.isLoading'(newVal) {
      if (!newVal) {
        this.$nextTick(() => {
          this.svgResize();
          this.svgResize2();
        });
      }
    },
    // redeemCouponCode() {
    //     // 假設規則：超過五位數則開啟QRcode彈窗
    //     if (this.redeemCouponCode === '000000') {
    //         this.lbQRcodeOpen = true;
    //         this.timer();
    //     } else if (this.redeemCouponCode.length > 5) {
    //         this.lbErrorOpen = true;
    //     }
    // },
  },
}
</script>
<style lang="scss" scoped>
.btn-container {
  cursor: pointer;
  background-color: #ff9f4b;
  padding: 12px 16px;
  width: 218px;
  height: 48px;
  margin: 0 auto;
  border-radius: 18px;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  &:active {
      background-color: #D16200;
  }
}
.warn_word{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #D16200;
  font-weight: 500;
  font-size: 14px;
  line-height: 16.8px;
  letter-spacing: 4%;
  width: 70px;
}
.non_see {
  filter: opacity(0.2);
}
.is_init {
  filter: opacity(1) !important;
}
.is_get {
  filter: opacity(0.08);
}
.non_click {
  filter: grayscale(1);
  pointer-events: none;
  background-color: #F2F2F2;
  color: #6F6F6F;
}
.btn {
  margin-top: 37px !important;
  margin-bottom: 40px !important;
}
.ticket_container{
  position: relative;
  filter: drop-shadow(0px 2px 2px #4b251825);
  margin: 16px 0 24px;
  .dot_container{
    position: absolute;
    z-index: 1;
    left: 0;
    width: 100%;
    height: 3px;
    display: flex;
    justify-content: space-evenly;
    .dot{
      width: calc(100% / 10 - 22px);
      background: radial-gradient(circle, rgba(187, 187, 187, 0.295) 0%, rgba(187, 187, 187, 0.322) 100%);
      border-radius: 24px;
      height: 100%;
      transform: translateY(-50%);
    }
  }
  .d_ticket {
    position: relative;
    padding: 16px 0 21px;
    top: 0;
    left: 0;
    background-color: #fffbf5;
    width: 100%;
    height: 100%;
  }
  .d_ticket2 {
    transform: translateY(-1px);
    padding: 21px 0px;
    top: 0;
    left: 0;
    background-color: #fffbf5;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}
.article {
  // padding-bottom: 37px;
  h2 {
    color: $color_main_first;
    font-size: 26px;
    font-weight: bold;
    padding: 12px 0;
    line-height: 1;
    text-align: left;
    position: relative;
  }
  .title_area,
  .content {
    padding: 0 32px;
  }

  .title_area {
    > .detail_area {
      justify-content: space-between;
      border-bottom: solid 1px #CCCCCC;
      padding-bottom: 30px;
      margin-bottom: 24px;
      .detail {
        display: flex;
        flex-direction: column;
        gap: 10px;
        text-align: left;
        font-size: 12px;
        line-height: 16px;
        padding-top: 8px;
        font {
          padding-right: 8px;
          color: $color_main_second;
          font-weight: bold;
        }
        span {
          color: $color_main_grey;
        }
      }
      .arrow_area {
        align-items: center;
        div {
          font-size: 17px;
          color: $color_main_first;
          transition: all 0.3s;

          img {
            margin: 0 4px;
            width: 30px;
          }
          &.prev {
            margin-right: 16px;
          }
          &.next {
            img {
              transform: rotate(180deg);
            }
          }

          &:active {
            opacity: 0.8;
          }
        }
        * {
          line-height: 48px;
          display: inline-flex;
        }
      }
    }
  }

  .content {
    text-align: left;

    h5 {
      padding: 8px 0 12px;
      color: $color_main_first;
      font-weight: bold;
      font-size: 18px;
      line-height: 21px;
    }
    p {
      line-height: 18px;
      font-size: 14px;
    }
  }
  button {
    margin-top: 30px;
    &.grey {
      background-color: #fff;
      color: #fff;
    }
  }
  .no_border {
    width: calc(100% - 48px);
    margin: 24px auto 0;
  }
  .done_img {
    position: absolute;
    width: 130px;
    bottom: 0;
    transform: translate(50%, -25%);
    z-index: 1;
  }
}
.dialog_box {
  p {
    color: $color_main_first;
    line-height: 1;
  }
  a,
  button {
    width: 100%;
    line-height: 48px !important;
    height: 48px !important;
    font-size: 16px;
  }
  font {
    font-size: 14px;
    display: block;
  }
}
.lb {
  .d_flex {
    flex-direction: column;
    .paw {
      width: 84px;
      margin: 45px auto 10px;
    }
    .f_grey {
      margin-bottom: 30px;
    }
    .qrcode_wrapper {
      max-width: 224px;
      margin: 0 auto 12px;
    }
  }
}
</style>
